import { render, staticRenderFns } from "./pictogram-admin-panel.vue?vue&type=template&id=1745865a&scoped=true"
import script from "./pictogram-admin-panel.vue?vue&type=script&lang=js"
export * from "./pictogram-admin-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745865a",
  null
  
)

export default component.exports